import Base from './Base';

class Citas extends Base {

    constructor () {
        super();
        this.endpoint = 'citas';
    }

    unavailableSchedule( ) {
        
        return  fetch(this.getUrlEndpoint("unavailable"),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
        
    }

    getHorariosDisponibles( data ){
        return  fetch(this.getUrlEndpoint("horarios-disponibles"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

    getDiasDisponiblesMes( month, year, mts, type , emplayado = 0){
        return  fetch(this.getUrlEndpoint(`dias-disponibles/${year}/${month}/${mts}/${type}/${emplayado}`),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    
}

export default Citas;